import { APIClient } from "../../../helpers/api_helper";
const api = new APIClient();

export const checkEvery8DStatus = async (tenantHandle) => {
  return api.get(`/admin/${tenantHandle}/every8d/check`);
};

export const connectEvery8D = async (tenantHandle, credentials) => {
  return api.create(`/admin/${tenantHandle}/every8d/connect`, credentials);
};

export const disconnectEvery8D = async (tenantHandle) => {
  return api.create(`/admin/${tenantHandle}/every8d/disconnect`);
};
